import { MessageFormatElement } from 'react-intl';
import en from './translations/en.json';
import es from './translations/es.json';
import de from './translations/de.json';
import fr from './translations/fr.json';

export const messages: Record<string, Record<string, string | MessageFormatElement[]>> = {
    'en': en,
    'es': es,
    'de': de,
    'fr': fr,
};
